import { render } from "./WizardProgress.vue?vue&type=template&id=127ca8a6&scoped=true"
import script from "./WizardProgress.vue?vue&type=script&lang=js"
export * from "./WizardProgress.vue?vue&type=script&lang=js"

import "./WizardProgress.vue?vue&type=style&index=0&id=127ca8a6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ca8a6"]])

export default __exports__